import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { XIcon, SparklesIcon } from 'lucide-react';
export function Nadi() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const handleCloseModal = () => {
    setShowModal(false);
    navigate('/reports');
  };
  return <div className="flex gap-6" data-id="element-7288">
      {/* Left Sidebar - Report Templates */}
      <div className="w-64 flex-shrink-0" data-id="element-7289">
        <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-7290">
          <input type="text" placeholder="Search" className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md mb-4" data-id="element-7291" />

          <div className="space-y-6" data-id="element-7292">
            <div data-id="element-7293">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-7294">
                Basic Reports
              </h3>
              <div className="space-y-1" data-id="element-7295">
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7296">
                  <div className="font-medium" data-id="element-7297">Daily activity</div>
                  <div className="text-xs text-gray-500" data-id="element-7298">
                    Sales, refunds, adjustments, and disputes
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7299">
                  <div className="font-medium" data-id="element-7300">Daily balance</div>
                  <div className="text-xs text-gray-500" data-id="element-7301">
                    Account balance and activity summary
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7302">
                  <div className="font-medium" data-id="element-7303">Monthly summary and balance</div>
                  <div className="text-xs text-gray-500" data-id="element-7304">
                    Sales, refunds, gross, and net activity
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7305">
                  <div className="font-medium" data-id="element-7306">Gross Volume</div>
                  <div className="text-xs text-gray-500" data-id="element-7307">
                    Gross volume query - used to match home chart Gross Volume
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7308">
                  <div className="font-medium" data-id="element-7309">Failed Payments</div>
                  <div className="text-xs text-gray-500" data-id="element-7310">
                    Failed payments sorted by descending order of time
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7311">
                  <div className="font-medium" data-id="element-7312">New Customers</div>
                  <div className="text-xs text-gray-500" data-id="element-7313">
                    Monthly count of new customers
                  </div>
                </button>
              </div>
            </div>

            <div data-id="element-7314">
              <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-7315">
                Payments, Payouts and Transfers
              </h3>
              <div className="space-y-1" data-id="element-7316">
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7317">
                  <div className="font-medium" data-id="element-7318">
                    Gross charge volume by month
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-7319">
                    Total processing volume for each currency per month
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7320">
                  <div className="font-medium" data-id="element-7321">Payment card breakdown</div>
                  <div className="text-xs text-gray-500" data-id="element-7322">
                    Charges and amounts for each card brand and type by currency
                  </div>
                </button>
                <button className="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7323">
                  <div className="font-medium" data-id="element-7324">Payments info breakdown</div>
                  <div className="text-xs text-gray-500" data-id="element-7325">
                    Summary of address info submitted with charges
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1" data-id="element-7326">
        <div className="flex items-center gap-4 mb-6" data-id="element-7327">
          <h1 className="text-2xl font-semibold text-gray-400" data-id="element-7328">
            Untitled report
          </h1>
          <button className="text-gray-400 hover:text-gray-600" data-id="element-7329">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" data-id="element-7330">
              <path d="M11.013 2.513a1.75 1.75 0 012.475 2.474l-8.61 8.61a.75.75 0 01-.353.194l-3.75.75a.75.75 0 01-.877-.877l.75-3.75a.75.75 0 01.194-.353l8.61-8.61z" data-id="element-7331" />
            </svg>
          </button>
        </div>

        <div className="flex gap-4 mb-6 border-b border-gray-200" data-id="element-7332">
          <button className="px-4 py-2 text-sm font-medium text-gray-700 border-b-2 border-transparent hover:border-gray-300" data-id="element-7333">
            Reports
          </button>
          <button className="px-4 py-2 text-sm font-medium text-gray-700 border-b-2 border-transparent hover:border-gray-300" data-id="element-7334">
            Schema
          </button>
          <button className="px-4 py-2 text-sm font-medium text-blue-600 border-b-2 border-blue-600" data-id="element-7335">
            Templates
          </button>
        </div>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 flex items-start gap-3 mb-4" data-id="element-7336">
          <SparklesIcon size={20} className="text-blue-600 flex-shrink-0 mt-0.5" data-id="element-7337" />
          <div className="flex-1" data-id="element-7338">
            <p className="text-sm text-gray-700" data-id="element-7339">
              <button className="font-medium text-blue-600 hover:text-blue-700" data-id="element-7340">
                Generate
              </button>
              {' | '}
              <button className="font-medium text-blue-600 hover:text-blue-700" data-id="element-7341">
                Ask Nadi Assistant
              </button>{' '}
              (ex: get me all connected accounts with transactions this month)
            </p>
          </div>
        </div>

        <div className="bg-orange-50 border border-orange-200 rounded-lg p-4 flex items-start gap-3" data-id="element-7342">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor" className="text-orange-600 flex-shrink-0 mt-0.5" data-id="element-7343">
            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" data-id="element-7344" />
          </svg>
          <div className="flex-1" data-id="element-7345">
            <p className="text-sm text-gray-700" data-id="element-7346">
              A nadi plan is required to use this feature.
            </p>
            <p className="text-sm text-gray-600 mt-1" data-id="element-7347">
              We have already been notified of the problem, but please don't
              hesitate to contact us if you have any questions.
            </p>
          </div>
        </div>
      </div>

      {/* Modal */}
      {showModal && <>
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={handleCloseModal} data-id="element-7348" />
          <div className="fixed inset-0 flex items-center justify-center z-50 p-4" data-id="element-7349">
            <div className="bg-white rounded-lg shadow-2xl max-w-2xl w-full p-8 relative" data-id="element-7350">
              <button onClick={handleCloseModal} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600" data-id="element-7351">
                <XIcon size={24} data-id="element-7352" />
              </button>

              <h2 className="text-2xl font-semibold text-gray-900 mb-6" data-id="element-7353">
                Custom reporting with an AI assistant
              </h2>

              <div className="flex gap-6" data-id="element-7354">
                {/* Left side - Preview */}
                <div className="flex-shrink-0" data-id="element-7355">
                  <div className="bg-gradient-to-br from-purple-100 to-blue-100 rounded-lg p-4 w-64" data-id="element-7356">
                    <div className="bg-white rounded-lg p-4 shadow-sm" data-id="element-7357">
                      <div className="flex items-center justify-between mb-3" data-id="element-7358">
                        <h3 className="text-sm font-semibold text-gray-900" data-id="element-7359">
                          Gross volume
                        </h3>
                        <button className="text-xs text-gray-500" data-id="element-7360">Edit</button>
                      </div>
                      <p className="text-xs text-gray-500 mb-3" data-id="element-7361">
                        Show recurring payments under RM24
                      </p>

                      {/* Mini chart */}
                      <div className="h-24" data-id="element-7362">
                        <svg width="100%" height="100%" viewBox="0 0 200 80" className="text-blue-600" data-id="element-7363">
                          <polyline points="10,60 30,50 50,55 70,40 90,45 110,35 130,40 150,25 170,30 190,20" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-7364" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right side - Content */}
                <div className="flex-1" data-id="element-7365">
                  <p className="text-gray-700 mb-4" data-id="element-7366">
                    Get quick answers to complex data questions with the AI
                    assistant. Use natural language to create and edit custom
                    reports—no need to learn SQL.
                  </p>

                  <p className="text-gray-700 mb-4" data-id="element-7367">
                    Try it free until January 4, 2026, then starting at{' '}
                    <span className="font-medium" data-id="element-7368">RM 50/month</span>, plus a{' '}
                    <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-7369">
                      per charge fee
                    </a>
                    .
                  </p>

                  <p className="text-xs text-gray-600 mb-6" data-id="element-7370">
                    By clicking "Start free trial", you enroll in an
                    automatically renewing subscription. You authorize Maybank
                    to debit all fees from your Maybank Balance after your free
                    trial ends. Cancel anytime in your{' '}
                    <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-7371">
                      settings
                    </a>
                    .
                  </p>

                  <div className="flex gap-3" data-id="element-7372">
                    <button className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-sm" data-id="element-7373">
                      Start free trial →
                    </button>
                    <button className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-md" data-id="element-7374">
                      Learn more
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>}
    </div>;
}